import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { _ as _object_without_properties } from "@swc/helpers/_/_object_without_properties";
import { jsx as _jsx } from "react/jsx-runtime";
import { TopShop } from "@faire/design-tokens";
import { Avatar } from "@faire/web--source/slate/Avatar";
import { TrophyIcon } from "@faire/web--source/slate/icons/Trophy";
import { Row } from "@faire/web--source/slate/Layout";
import { isResponsiveProp } from "@faire/web--source/slate/Theme/ResponsiveProp";
import { useResponsiveValue } from "@faire/web--source/ui/hooks/useResponsiveValue";
import { useViewport } from "@faire/web--source/ui/hooks/useViewport";
import React from "react";
import styled from "styled-components";
import { TopShopEducationTooltip } from "@faire/retailer/components/TopShop/TopShopTooltip";
import { useEventsStore } from "@faire/retailer/stores/domain/Events/shared/EventsStore";
import { useTopShopVisibility } from "../TopShop/useTopShopVisibility";
export var BrandAvatar = function(_param) {
    var isTopShop = _param.isTopShop, iconSize = _param.iconSize, displayTooltip = _param.displayTooltip, hideIcon = _param.hideIcon, hideTopShopBorder = _param.hideTopShopBorder, avatarProps = _object_without_properties(_param, [
        "isTopShop",
        "iconSize",
        "displayTooltip",
        "hideIcon",
        "hideTopShopBorder"
    ]);
    var viewport = useViewport();
    var responsiveSize = useResponsiveValue(isResponsiveProp(avatarProps.size) ? avatarProps.size : {
        mobileAndAbove: avatarProps.size
    });
    var iconSizeMap = {
        "xx-small": "16px",
        "x-small": "16px",
        smaller: "16px",
        small: "16px",
        medium: "22px",
        large: "22px",
        "x-large": "22px"
    };
    var _useEventsStore = useEventsStore([
        "nextOrActiveEventTheme"
    ]), eventTheme = _useEventsStore.nextOrActiveEventTheme;
    var isTopShopContentVisibleForBrand = useTopShopVisibility(isTopShop).isTopShopContentVisibleForBrand;
    if (isTopShopContentVisibleForBrand) {
        var fontSize = iconSize !== null && iconSize !== void 0 ? iconSize : iconSizeMap[responsiveSize];
        var baseIcon = /*#__PURE__*/ _jsx(TrophyIcon, {
            active: true,
            fontSize: fontSize,
            titleAccess: ""
        });
        var icon = displayTooltip && viewport.isDesktopAndAbove ? /*#__PURE__*/ _jsx(TopShopEducationTooltip, {
            icon: baseIcon
        }) : baseIcon;
        return /*#__PURE__*/ _jsx(TopShopAvatarContainer, {
            children: /*#__PURE__*/ _jsx(TopShopAvatar, _object_spread_props(_object_spread({}, avatarProps), {
                iconData: hideIcon ? undefined : {
                    position: "bottomRight",
                    icon: icon
                },
                borderColor: hideTopShopBorder ? undefined : TopShop.shade.green,
                theme: eventTheme
            }))
        });
    }
    return /*#__PURE__*/ _jsx(Avatar, _object_spread_props(_object_spread({}, avatarProps), {
        theme: eventTheme
    }));
};
var TopShopAvatar = styled(Avatar).withConfig({
    componentId: "sc-33547e54-0"
})([
    "background-color:unset;"
]);
var TopShopAvatarContainer = styled(Row).withConfig({
    componentId: "sc-33547e54-1"
})([
    "position:relative;z-index:1;height:fit-content;"
]);
